
//const BASE_URL = "/";
//  const BASE_URL = "https://3.108.41.199:9000/";
//  const BASE_URL = "http://13.232.27.13:5000/";

// https://dev.msilruralmaps.com:9000
// const BASE_URL ="https://dev.msilruralmaps.com:9000/";
// export const ENV_URL=`${process.env.REACT_APP_ENV_URL}`||"https://dev.msilcommercialsalesmaps.com/"
// const BASE_URL2=`${ENV_URL}api/`
export const ENV_URL=`${process.env.REACT_APP_ENV_URL}`||"https://dev.msilruralmaps.com/"
// console.log(ENV_URL)
const BASE_URL=`${ENV_URL}api/`
// const BASE_URL ="https://uat.msilruralmaps.com/api/";


export const admin_boundary_base_url = BASE_URL + "getboundary";
export const POI_base_url = BASE_URL + "poi";
export const POI_Census_Count_url = BASE_URL + "poiredshift";
export const Employee_level_url = BASE_URL + "Outlet";
export const RoadNetwork_url = BASE_URL + "roadnetworks";
export const HeatMap_url = BASE_URL + "heatmap";
export const Mapfilter_url = BASE_URL + "mapfilter";
export const Login_url = BASE_URL + "loginadfs";
export const Login_dealer_url = Login_url + '/' + 'dealer';
export const SignUpUrl = BASE_URL + "signup";
export const AdminUrl = BASE_URL + "user";
export const UpdateUserUrl = BASE_URL+"admin/update";
//////////////////////////New phase/////////////////////
export const Dealer_URL=BASE_URL+"dealerLogin";
export const UTILITY_State_name_url=BASE_URL+"getstatename";
export const RDSE_COUNT=BASE_URL+"rdsecount";
export const DEALER_LOGIN_URL=BASE_URL+"mspin";
export const USER_AUTH=BASE_URL+"authlogin";
export const LAST_UPDATED=BASE_URL+'lastupdate'
export const BaseURL=BASE_URL;

////////////////////////////////////////////////////////


export const admin_boundary_layersName = {'State':'Uttar_pradesh_admin_boundary',
'District':'Uttar_pradesh_districts_admin_boundary',
'Sub_District':'Uttar_pradesh_subdistrict_admin_boundary',
'Village':'Uttar_pradesh_village_admin_boundary'};

export const featureName = {'State':'STATE_NAME',
'District':'DIST_NAME',
'Sub_District':'SUBDIST_NAME',
'Village':'VIL_NAME'};

export const level_arr = ['State','District','Sub_District','Village'];




export const POI_layersName = {
            "Hospitals" : "POI_Hospitals",
            'Banks' : "POI_Banks",
            'Schools' : "POI_Schools",
            'Petrol pumps' : "POI_Petrol_Pumps",
            'CNG' : "POI_CNG_Pumps",
            'Industrial Centers' : "POI_Industrial_Center",
            'APMCS' : "POI_Agri_Mandis",
            'Transport Nagar' : "POI_Transport_Nagar"
            
};

